import React, { useState, useEffect, useMemo } from "react";
import { DialogBox } from "../../../../../components/Elements/DialogBox";
import { Button } from "antd";
import { useSelector, useDispatch } from "react-redux";
import {
  createMapping,
  fetchDepartmentLinkedEntities,
} from "../../../../../redux/OrganizationSetup/organizationSetupSlice";
import PopupCard from "../../../../Auth/PopupCard";
const AssignDepartment = ({ onOpen, onClose, locationId }) => {
  const dispatch = useDispatch();
  const { departmentList } = useSelector((state) => state.orgSetup);
  const { linkedDepartments = [] } = useSelector((state) => state.orgSetup);

  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [popup, setPopup] = useState({
    type: "",
    visible: false,
    title: "",
    message: "",
  });

  // Fetch departments when dialog opens
  useEffect(() => {
    const fetchData = async () => {
      if (!onOpen || !locationId) return;
      try {
        await dispatch(
          fetchDepartmentLinkedEntities({ id: locationId }),
        ).unwrap();
      } catch (err) {
        console.error(err);
        setPopup({
          type: "error",
          visible: true,
          title: "Error",
          message:
            typeof err === "string"
              ? err
              : err?.message || "Failed to fetch linked departments.",
        });
        setTimeout(() => {
          setPopup((prev) => ({ ...prev, visible: false }));
        }, 3000);
      }
    };
    fetchData();
  }, [onOpen, locationId, dispatch]);

  // Preselect linked departments (after removing null values if any)

  const cleanLinkedDepartments = useMemo(
    () => linkedDepartments?.filter(Boolean) || [],
    [linkedDepartments],
  );

  useEffect(() => {
    setSelectedDepartments(cleanLinkedDepartments.map((d) => d._id));
  }, [cleanLinkedDepartments]);

  const handleCheck = (id) => {
    setSelectedDepartments((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  //SAVE DATA
  const handleSave = async () => {
    try {
      const res = await dispatch(
        createMapping({
          parentId: locationId,
          childIds: selectedDepartments,
          mappingContext: "locationDepartments",
        }),
      ).unwrap();
      if (res?.success) {
        setPopup({
          type: "success",
          visible: true,
          title: "Success",
          message:
            "Location and Department linked successfully!" || res?.message,
        });

        setTimeout(() => {
          onClose();
        }, 1200);
      } else {
        setPopup({
          type: "error",
          visible: true,
          title: "Not Assigned",
          message: res?.message,
        });
        setTimeout(() => {
          onClose();
        }, 1000);
      }
    } catch (err) {
      console.error(err || "Something went wrong");
      setPopup({
        type: "error",
        visible: true,
        title: "Error",
        message:
          typeof err === "string"
            ? err
            : err?.message ||
              "Something went wrong while assigning departments.",
      });
      setTimeout(() => {
        setPopup((prev) => ({ ...prev, visible: false }));
      }, 3000);
    }
  };

  return (
    <div>
      <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
        <div className="p-4">
          <h2 className="text-lg font-semibold text-[#06513D] mb-4">
            Add Departments
          </h2>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 max-h-[400px] overflow-y-auto pr-2 custom-scrollbar">
            {[...departmentList]
              .sort((a, b) => {
                // Get the index in the already linked items list
                const aIndex = (linkedDepartments || []).findIndex(
                  (d) => d?._id === a._id,
                );

                const bIndex = (linkedDepartments || []).findIndex(
                  (d) => d?._id === b._id,
                );

                const aIsLinked = aIndex !== -1;
                const bIsLinked = bIndex !== -1;

                // If both are linked, sort by their index in the linkedDepartments array
                if (aIsLinked && bIsLinked) {
                  return aIndex - bIndex;
                }

                // Otherwise, just ensure linked ones are at the top
                return bIsLinked - aIsLinked;
              })
              .map((dept) => (
                <label
                  key={dept._id}
                  className="flex items-center gap-2 cursor-pointer"
                >
                  <input
                    type="checkbox"
                    checked={selectedDepartments.includes(dept._id)}
                    onChange={() => handleCheck(dept._id)}
                    className="w-4 h-4 accent-[#06513D]"
                  />
                  <span className="text-[15px] font-medium text-[#2D2D2D]">
                    {dept.name}
                  </span>
                </label>
              ))}
          </div>

          <div className="flex justify-end gap-3 mt-6">
            <Button
              onClick={onClose}
              className="hover:!bg-[#F8F8F8] hover:!border-[#06513D] hover:!text-[#06513D] "
            >
              Cancel
            </Button>

            <Button
              type="primary"
              style={{ background: "#06513D" }}
              onClick={handleSave}
              className="hover:!bg-[#387464] hover:!text-[#ffffff] hover:border-[#E6EDEB]"
            >
              Save
            </Button>
          </div>
        </div>
      </DialogBox>
      {/*  Popup */}
      {popup.visible && (
        <div className="fixed inset-0 bg-black/30 z-[9999] flex items-center justify-center">
          <PopupCard
            type={popup.type}
            title={popup.title}
            message={popup.message}
          />
        </div>
      )}
    </div>
  );
};

export default AssignDepartment;
